import { Logger } from "aws-amplify";
import AppSettings from "@/config/appsettings.json";

const LOG_LEVELS: Record<string, string> = {
  verbose: "VERBOSE",
  debug: "DEBUG",
  info: "INFO",
  warn: "WARN",
  error: "ERROR",
  none: "NONE"
}

function getLogLevel(): string {
  try {
    const logLevel = LOG_LEVELS[AppSettings.LogLevel];
    if (logLevel == null || logLevel == undefined)
      throw new Error("Improper log level config");
    return logLevel;
  } catch (e) {
    return LOG_LEVELS.None;
  }
}

const LOG_LEVEL = getLogLevel();

const logger = new Logger("LoggerService", LOG_LEVEL);

export function verbose(msg: any): void {
  logger.verbose(msg);
}

export function debug(msg: any): void {
  logger.debug(msg);
}

export function info(msg: any): void {
  logger.info(msg);
}

export function warn(msg: any): void {
  logger.warn(msg);
}

export function error(msg: any): void {
  logger.error(msg);
}
